'use client';

import { createContext, useContext } from 'react';

import { usePreviewFrameReady } from '@/components/Contexts/PreviewFrameReadyContext';
import { useWixInstance } from '@/hooks/useWixInstance';

const WixInstanceContext = createContext<string | null>(null);

export function WixInstanceProvider({
  siteUrl,
  skipInstanceFetch,
  children,
}: {
  siteUrl: string;
  skipInstanceFetch?: boolean;
  children: React.ReactNode;
}) {
  // The instance token encodes the visitor identity as it stands when it is
  // minted, and the preview frame is what establishes that identity on a site
  // with no session yet -- so fetch it only once the frame has reported ready.
  const { frameEverReady } = usePreviewFrameReady();
  const { data: instance = null } = useWixInstance(siteUrl, {
    enabled: !skipInstanceFetch && frameEverReady,
  });
  return (
    <WixInstanceContext.Provider value={instance}>
      {children}
    </WixInstanceContext.Provider>
  );
}

export function useWixInstanceContext() {
  return useContext(WixInstanceContext);
}
